import { createSlice } from '@reduxjs/toolkit';

function getDefaultDates() {
  const end = new Date();
  const start = new Date();
  start.setDate(end.getDate() - 30);
  return {
    startDate: start.toISOString().slice(0, 10),
    endDate: end.toISOString().slice(0, 10),
  };
}

const initialState = {
  filters: {
    ...getDefaultDates(),
    status: 'Active',
    username: '',
    role: '',
    pageSize: 10,
  },
  tempFilters: {
    ...getDefaultDates(),
    status: 'Active',
    username: '',
    role: '',
    pageSize: 10,
  },
  page: 1,
  sort: { key: '', direction: 'asc' },
  useDates: false,
};

const usersListSlice = createSlice({
  name: 'usersList',
  initialState,
  reducers: {
    setFilters(state, action) {
      state.filters = action.payload;
      state.page = 1; // Reset page when filters change
    },
    setTempFilters(state, action) {
      state.tempFilters = action.payload;
    },
    setPage(state, action) {
      state.page = action.payload;
    },
    setSort(state, action) {
      state.sort = action.payload;
    },
    setUseDates(state, action) {
      state.useDates = action.payload;
      state.page = 1; // Reset page when date usage changes
    },
    clearUsersListFilters(state) {
      state.filters = initialState.filters;
      state.tempFilters = initialState.tempFilters;
      state.page = 1;
      state.useDates = false;
    },
  },
});

export const {
  setFilters,
  setTempFilters,
  setPage,
  setSort,
  setUseDates,
  clearUsersListFilters,
} = usersListSlice.actions;

export default usersListSlice.reducer;
